// extracted by mini-css-extract-plugin
export default {"cirkelContainer":"Cirkel_cirkelContainer__MgBZ0","aktivCirkel":"Cirkel_aktivCirkel__hRSdL"};